const service = () => {
    if (!$(".services").length) return;

    $('.package-slide').slick({
        dots: true,
        infinite: true,
        speed: 500,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        arrows: false,
        row: 1,
        //   slidesPerRow: 3,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
}

module.exports = service
